import { render, staticRenderFns } from "./bars-up.vue?vue&type=template&id=e508a7de&scoped=true&"
import script from "./bars-up.vue?vue&type=script&lang=js&"
export * from "./bars-up.vue?vue&type=script&lang=js&"
import style0 from "./bars-up.vue?vue&type=style&index=0&id=e508a7de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e508a7de",
  null
  
)

export default component.exports